import { render, staticRenderFns } from "./authorizationrecord.vue?vue&type=template&id=63ba8bd3&scoped=true"
import script from "./authorizationrecord.vue?vue&type=script&lang=js"
export * from "./authorizationrecord.vue?vue&type=script&lang=js"
import style0 from "./authorizationrecord.vue?vue&type=style&index=0&id=63ba8bd3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ba8bd3",
  null
  
)

export default component.exports